import React, { useEffect, useState } from "react";
import AllSchoolInvoices from "./AllSchoolInvoices";
import AllSchoolCredits from "./AllSchoolCredits";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "../../Dashbord/DashboardCustom.css";
import ToastHOC from "../../HOC/ToastHOC";
import { useTranslation } from "react-i18next";
import Util from "../../../Util";
import { getUpdatedSchool } from "../../../components/CommonApis";
import Loader from "../../../components/common/Loader";

function BillingReports(props) {
  const { t } = useTranslation();
  const { setIsToast } = props;
  const [value, setValue] = React.useState("Invoices");
  const school = Util.getSelectedSchool();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [isSchool, setIsSchool] = useState(null);
  const [schoolLoading, setSchoolLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const schooldata = await getUpdatedSchool(school.id);
      setIsSchool(schooldata);
      setSchoolLoading(false);
    }

    fetchData();
  }, [school.id]);

  if (schoolLoading) {
    return <Loader />;
  }

  if (!isSchool?.billing) {
    return (
      <div
        className="d-flex justify-content-center"
        style={{
          fontWeight: "bold",
          fontSize: "20px",
          color: "#ed3131",
          alignItems: "center",
          height: "500px",
        }}
      >
        Module Access Denied
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="body">
        <div className="col-lg col-md-12 p-3">
          <div className="row py-3">
            <div className="col-md-4">
              <h2 className="page-head">{t("Reports")}</h2>
            </div>
            <div className="col-md-8"></div>
          </div>
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: "#6418c3",
                  height: 2,
                },
              }}
            >
              <Tab
                sx={{
                  fontFamily: "Public Sans, sans-serif",
                  textTransform: "none",
                  "&.Mui-selected": {
                    color: "#6418c3",
                    fontWeight: "600",
                  },
                }}
                value="Invoices"
                label={t("Invoices")}
              />
              <Tab
                sx={{
                  fontFamily: "Public Sans, sans-serif",
                  textTransform: "none",
                  "&.Mui-selected": {
                    color: "#6418c3",
                    fontWeight: "600",
                  },
                }}
                value="Credits & Payments"
                label={t("Payments")}
              />
            </Tabs>
          </Box>
          {value === "Invoices" && (
            <AllSchoolInvoices
              message={(msg) => {
                setIsToast(msg);
              }}
            />
          )}
          {value === "Credits & Payments" && <AllSchoolCredits />}
        </div>
      </div>
    </div>
  );
}
export default ToastHOC(BillingReports);
